module.exports = __webpack_public_path__ + "static/media/alunosModal.e1d942f7.jpg";